import { db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const DEFAULT_CONFIG = { mode: 'live', publishableKeyTest: '', publishableKeyLive: '' };

export async function getStripeConfig() {
  const snap = await getDoc(doc(db, 'settings', 'stripeConfig'));
  return snap.exists() ? { ...DEFAULT_CONFIG, ...snap.data() } : { ...DEFAULT_CONFIG };
}

export async function saveStripeConfig({ mode, publishableKeyTest, publishableKeyLive }) {
  await setDoc(
    doc(db, 'settings', 'stripeConfig'),
    { mode, publishableKeyTest: publishableKeyTest || '', publishableKeyLive: publishableKeyLive || '', updatedAt: serverTimestamp() },
    { merge: true },
  );
}

export async function getActivePublishableKey() {
  const config = await getStripeConfig();
  if (config.mode === 'test') {
    return config.publishableKeyTest || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  }
  return config.publishableKeyLive || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
}
